import { Button, EmptyState, NotStartedIcon } from '@lmc/ui-kit'
import Rota from '@lmc/ui-kit/src/dataDisplay/EmptyState/icons/Rota'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Spinner } from 'components/generic'
import { START_OVERLAY_TYPE } from 'screens/Rostering/types'
import { AddRotaPatternDropdown } from './AddRotaPatternDropdown'
import { commonPatterns } from 'utils/enhancedTestIds'

type StartRotaOverlayProps = {
  'data-testid'?: string
  onStartRota: () => void
  isLoading: boolean
  hasEvents: boolean
  type?: START_OVERLAY_TYPE
}

const StartRotaOverlay = ({
  'data-testid': dataTestId,
  onStartRota,
  isLoading,
  hasEvents,
  type
}: StartRotaOverlayProps) => {
  const { t } = useTranslation()
  const baseId = dataTestId || 'start-rota-overlay'
  const noRota = type === START_OVERLAY_TYPE.NO_ROTA
  const noPatterns = type === START_OVERLAY_TYPE.NO_PATTERNS

  if (isLoading) {
    return (
      <TableOverlay>
        <SpinnerContainer>
          <Spinner />
        </SpinnerContainer>
      </TableOverlay>
    )
  }

  if (hasEvents || !type) {
    return null
  }

  return (
    <TableOverlay data-testid={baseId}>
      <EmptyStateContainer
        data-testid={commonPatterns.field(baseId, 'empty-state')}
      >
        {noRota && (
          <EmptyState
            title={t('ROTA_NOT_STARTED')}
            description={t('ROTA_NOT_STARTED_DESCRIPTION')}
            icon={<Rota />}
          >
            <Button
              variant="primary"
              onClick={onStartRota}
              data-testid={commonPatterns.button(baseId, 'start')}
              data-intercom-target="start-draft-rota-button"
            >
              {t('START_DRAFT_ROTA')}
            </Button>
          </EmptyState>
        )}
        {noPatterns && (
          <EmptyState
            title={t('YOU_HAVE_NO_PATTERNS')}
            description={t('START_BUILDING_ROTA')}
            icon={<NotStartedIcon />}
          >
            <AddRotaPatternDropdown
              firstPattern
              testId={`${baseId}-add-pattern`}
            />
          </EmptyState>
        )}
      </EmptyStateContainer>
    </TableOverlay>
  )
}

const TableOverlay = styled.div`
  position: absolute;
  top: 66px;
  left: 1px;
  width: calc(100% - 2px);
  height: calc(100% - 67px);
  display: flex;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  z-index: 10;
`

const EmptyStateContainer = styled.div`
  margin-top: 12px;
`

const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`

export default StartRotaOverlay
